import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export const VIEW_AS_KEY = "marigot_view_as";
export const getViewAs = () => {
  try {
    return JSON.parse(sessionStorage.getItem(VIEW_AS_KEY)) || null;
  } catch {
    return null;
  }
};

api.interceptors.request.use((config) => {
  const v = getViewAs();
  if (v?.id) config.headers["X-View-As-Client"] = v.id;
  return config;
});

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Si è verificato un errore. Riprova.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export const fmtDate = (d) => (d ? new Date(d).toLocaleDateString("it-IT") : "—");
export const PERIOD_MONTHS = { mensile: 1, trimestrale: 3, annuale: 12, biennale: 24, triennale: 36 };
export const periodMonths = (s) => PERIOD_MONTHS[s.commitment || s.billing] || 1;
export const monthlyValue = (s) => (s.price || 0) / periodMonths(s);
export const billingPeriodCost = (s) => (PERIOD_MONTHS[s.billing] ? monthlyValue(s) * PERIOD_MONTHS[s.billing] : s.price || 0);
export const unitBillingPeriodCost = (s) => (s.quantity ? billingPeriodCost(s) / s.quantity : 0);
export const fmtEur = (n) =>
  new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(n || 0);
export const fmtSize = (b) =>
  b > 1048576 ? `${(b / 1048576).toFixed(1)} MB` : `${Math.max(1, Math.round((b || 0) / 1024))} KB`;

export const STATUSES = {
  attivo: { label: "Attivo", cls: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30" },
  in_scadenza: { label: "In scadenza", cls: "bg-amber-500/15 text-amber-400 border-amber-500/30" },
  in_attivazione: { label: "In attivazione", cls: "bg-sky-500/15 text-sky-400 border-sky-500/30" },
  sospeso: { label: "Sospeso", cls: "bg-rose-500/15 text-rose-400 border-rose-500/30" },
  scaduto: { label: "Scaduto", cls: "bg-slate-500/15 text-slate-400 border-slate-500/30" },
};

export const BILLINGS = { mensile: "Mensile", trimestrale: "Trimestrale", annuale: "Annuale", una_tantum: "Una tantum" };
export const COMMITMENTS = { mensile: "Mensile", trimestrale: "Trimestrale", annuale: "Annuale", biennale: "Biennale", triennale: "Triennale" };

export async function downloadBlob(url, filename) {
  const res = await api.get(url, { responseType: "blob" });
  const href = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = href;
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(href), 1000);
}

export const downloadDoc = (doc) => downloadBlob(`/documents/${doc.id}/download`, doc.filename);

export const exportSubscriptionsCsv = (clientId, label) =>
  downloadBlob(`/admin/subscriptions/export${clientId ? `?client_id=${clientId}` : ""}`,
    `abbonamenti_${(label || "tutti-i-clienti").toLowerCase().replace(/[^a-z0-9]+/g, "-")}_${new Date().toISOString().slice(0, 10)}.csv`);
